<script setup lang="ts">
import { inject } from "vue";
import { signOut } from "aws-amplify/auth";
import { retailInstanceTypeSymbol } from "@/models/Symbols";
import type { RetailInstanceTypeService } from "@/services/RetailInstanceTypeService";

const props = defineProps<{
    basketCount: number,
    isLoggedIn: boolean
}>();
const instanceTypeSvc = inject(retailInstanceTypeSymbol) as RetailInstanceTypeService;
const logout = async () => {
    try {
        await signOut();
    } catch (error) {
        console.error(error);
    }
};

function handleAdminLink() {
    window.location.href = "/corporate";
}
</script>
<template>
    <v-list>
        <v-list-item @click="$router.push({ name: 'your-basket' })"
            :class="{ 'nav-item-active': $route.name === 'your-basket' }">
            <v-list-item-title>Basket ({{ props.basketCount }})</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!props.isLoggedIn" @click="$router.push({ name: 'login' })"
            :class="{ 'nav-item-active': $route.name === 'login' }">
            <v-list-item-title>Login</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$router.push({ name: 'orders' })" :class="{ 'nav-item-active': $route.name === 'orders' }"
            v-if="props.isLoggedIn">
            <v-list-item-title>My Bookings</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!instanceTypeSvc.isConsumer()" @click="handleAdminLink()">
            <v-list-item-title>Admin</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="props.isLoggedIn" @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
    </v-list>
</template>

<style lang="scss" scoped>
@media (min-width: 768px) {
    .v-list {
        display: flex;
        flex-direction: row;
        margin-right: 20px;
        font-size: 1.1rem;
        font-weight: bold;
    }

    .v-list .v-list-item-title {
        font-weight: 500;
    }
}
</style>
